import { Component, OnInit } from '@angular/core';
import {ApiService} from '../../api.service';

@Component({
  selector: 'app-shaft-information',
  templateUrl: './shaft-information.component.html',
  styleUrls: ['./shaft-information.component.css']
})

export class ShaftInformationComponent implements OnInit {

  contact: {
    length: number;
  } = [];
  shaftContact = [];
  sectionContact = [];

  receivedCompanyID = 0;
  receivedCountryID = 1;
  receivedProvinceID = 0;
  receivedAreaID = 0;
  receivedShaftID = 0;
  receivedSectionID = 0;
  getReceivedCompanyID(message: number) {
    this.receivedCompanyID = message;
  }
  getReceivedProvinceID(message: number) {
    this.receivedProvinceID = message;
  }
  getReceivedAreaID(message: number) {
    console.log(message);
    this.receivedAreaID = message;
  }
  getReceivedShaftID(message: number) {
    this.receivedShaftID = message;
  }
  getReceivedSectionID(message: number) {
    this.receivedSectionID = message;
  }
  constructor(public restApi: ApiService) { }

  ngOnInit() {
  }

  loadContacts() {
    return this.restApi.getContacts(1).subscribe((data: {}) => {
      // @ts-ignore
      this.contact = data;
      this.getList();
    });
  }
  getList() {
    this.shaftContact = [];
    this.sectionContact = [];
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.contact.length; i++) {
      if (this.contact[i].sectionPositionName === 'Shaft') {
        this.shaftContact.push(this.contact[i]);
      } else {
        this.sectionContact.push(this.contact[i]);
      }
    }
    console.log(this.shaftContact);
  }
}
